import { Controller } from "@hotwired/stimulus"

// The budget can be entered in euros or in hours; editing either field derives
// the other from the hourly rate. Only the euro amount is submitted — the
// hours input has no name and exists purely as an entry convenience.
export default class extends Controller {
  static targets = ["rate", "money", "hours"]

  connect() {
    this.syncHoursFromMoney()
  }

  moneyChanged() {
    this.lastEdited = "money"
    this.syncHoursFromMoney()
  }

  hoursChanged() {
    this.lastEdited = "hours"
    this.syncMoneyFromHours()
  }

  // The last field the user typed in stays authoritative while the rate
  // changes; before any edit the persisted euro amount is the source.
  rateChanged() {
    if (this.lastEdited === "hours") {
      this.syncMoneyFromHours()
    } else {
      this.syncHoursFromMoney()
    }
  }

  syncHoursFromMoney() {
    const money = parseFloat(this.moneyTarget.value)

    if (Number.isNaN(money) || !(this.rate > 0)) {
      this.hoursTarget.value = ""
    } else {
      this.hoursTarget.value = this.round(money / this.rate)
    }
  }

  syncMoneyFromHours() {
    const hours = parseFloat(this.hoursTarget.value)

    if (Number.isNaN(hours)) {
      this.moneyTarget.value = ""
    } else if (this.rate > 0) {
      this.moneyTarget.value = this.round(hours * this.rate)
    }
  }

  get rate() {
    return parseFloat(this.rateTarget.value)
  }

  round(value) {
    return Math.round(value * 100) / 100
  }
}
